// ===================================================================
// 🔐 REDEFINIR SENHA - Tela após clicar no link do email
// ===================================================================

import React, { useState, useCallback } from 'react';
import { styles } from '../../styles/globalStyles';
import { Alert } from '../../components/ui/Alert';
import { apiClient } from '../../api/apiClient';
import { validateNewPassword, PASSWORD_POLICY_HINT } from '../../utils/passwordPolicy';

const EyeToggle = ({ visible, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    tabIndex={-1}
    style={{
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '4px',
      color: '#6B7280',
    }}
    title={visible ? 'Ocultar senha' : 'Ver senha'}
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      {visible ? (
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      ) : (
        <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></>
      )}
    </svg>
  </button>
);

export const ResetPasswordScreen = React.memo(({ token, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    const pwdErr = validateNewPassword(password);
    if (pwdErr) {
      setError(pwdErr);
      return;
    }
    if (password !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      await apiClient.auth.resetPassword({ token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Token inválido ou expirado');
    } finally {
      setLoading(false);
    }
  }, [token, password, confirmPassword]);

  if (success) {
    return (
      <div style={styles.authContainer}>
        <div style={styles.authBox}>
          <h1 style={styles.authTitle}>Senha alterada</h1>
          <p style={{ ...styles.authSubtitle, marginBottom: '24px' }}>
            Sua senha foi alterada com sucesso. Faça login com a nova senha.
          </p>
          <button onClick={onSuccess} style={{ ...styles.button, ...styles.buttonPrimary }}>
            Ir para o login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.authContainer}>
      <div style={styles.authBox}>
        <h1 style={styles.authTitle}>Redefinir senha</h1>
        <p style={{ ...styles.authSubtitle, marginBottom: '24px' }}>
          Digite sua nova senha abaixo.
        </p>
        <form onSubmit={handleSubmit} style={styles.form} autoComplete="off">
          {error && <Alert message={error} type="error" onClose={() => setError('')} />}
          <div style={{ marginBottom: '16px' }}>
            <label style={styles.label}>Nova senha *</label>
            <p style={{ fontSize: 13, color: '#6B7280', margin: '0 0 8px', lineHeight: 1.5 }}>{PASSWORD_POLICY_HINT}</p>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="new-password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ ...styles.input, paddingRight: '40px' }}
                placeholder="Mínimo 8 caracteres"
                minLength={8}
                required
              />
              <EyeToggle visible={showPassword} onToggle={() => setShowPassword(v => !v)} />
            </div>
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={styles.label}>Confirmar nova senha *</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                name="confirm-new-password"
                autoComplete="new-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ ...styles.input, paddingRight: '40px' }}
                placeholder="Repita a senha"
                required
              />
              <EyeToggle visible={showConfirmPassword} onToggle={() => setShowConfirmPassword(v => !v)} />
            </div>
          </div>
          <button type="submit" disabled={loading} style={{ ...styles.button, ...styles.buttonPrimary, width: '100%', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Salvando...' : 'Redefinir senha'}
          </button>
        </form>
      </div>
    </div>
  );
});
